import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SectiuniService } from '../../sectiuni/sectiuni.service';
import { ISectiune } from '../../sectiuni/sectiuni.interface';
import { PermisiuniService } from '../permisiuni.service';
import {
  IPermisiune,
  IPermisiuneForm,
  IPermisiuneUpdatePayload,
} from '../permisiuni.interface';

@Component({
  selector: 'app-edit-permisiune',
  templateUrl: './edit-permisiune.component.html',
  styleUrls: ['./edit-permisiune.component.scss'],
})
export class EditPermisiuneComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  isSectionsLoading = true;
  sections$!: Observable<ISectiune[]>;

  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name, [Validators.required]),
    section_id: new FormControl(this.data.section_id, [Validators.required]),
    observations: new FormControl(this.data.observations, []),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IPermisiune,
    private dialogRef: MatDialogRef<EditPermisiuneComponent>,
    private sectiuniService: SectiuniService,
    private permisiuniService: PermisiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getSectionsList();
  }

  getSectionsList() {
    this.sections$ = this.sectiuniService.getSections();
    this.sections$.subscribe({
      next: (sections) => {
        this.sections$ = of(sections);
        this.isSectionsLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isSectionsLoading = false;
      },
    });
  }

  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.permisiuniService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const { name, section_id, observations } = this.form
      .value as IPermisiuneForm;
    const slug = name
      .split(' ')
      .map((item) => item.toLowerCase())
      .join('_');
    const updatePermisiune: IPermisiuneUpdatePayload = {
      id: this.data.id,
      name,
      slug,
      section_id,
      observations,
    };

    this.permisiuniService
      .updatePermisiune(updatePermisiune)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(
          this.errorTitle,
          msg,
          this.errorIcon
        );
      });
    } else {
      let errorMessage =
        environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(
        this.errorTitle,
        errorMessage,
        this.errorIcon
      );
    }
  }
}
